(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ipx-product-confidence"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ipx-delivery-checker')) {
    class IpxDeliveryChecker extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.input = this.querySelector('input');
        this.status = this.querySelector('[role="status"]');
        this.map = this.querySelector('.ipx-delivery__map');
        this.querySelector('button').addEventListener('click', () => this.check(), options);
        this.input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.check(); } }, options);
        this.input.addEventListener('input', () => { this.requestId=(this.requestId||0)+1; this.hideMap(); this.status.classList.remove('is-estimate'); this.input.removeAttribute('aria-invalid'); this.status.textContent = this.dataset.empty; }, options);
        window.addEventListener('ipx-delivery-zip', event => { this.input.value = event.detail; this.check(false); }, options);
        try { const saved = sessionStorage.getItem('ipx-delivery-zip'); if (saved) { this.input.value=saved; this.check(false); } } catch {}
      }
      disconnectedCallback() { this.controller?.abort(); this.mapObserver?.disconnect(); }
      hideMap() { this.mapObserver?.disconnect(); this.map.hidden=true; this.map.replaceChildren(); }
      check(broadcast = true) {
        const requestId=this.requestId=(this.requestId||0)+1;
        this.hideMap();
        this.status.classList.remove('is-estimate');
        const zip = this.input.value.trim();
        if (!/^\d{5}(-\d{4})?$/.test(zip)) { this.input.setAttribute('aria-invalid','true'); this.status.textContent=this.dataset.invalid; return; }
        this.input.removeAttribute('aria-invalid');
        const prefix = Number(zip.slice(0,2));
        const regional = Number(zip.slice(0,3));
        let range = '';
        if ([1,2,6,7,8,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,27,28,29].includes(prefix)) range='1–2';
        else if ([30,31,35,36,37,38,39,40,41,43,44,45,46,47,48,49,53,54,60,61,62].includes(prefix)) range='2–3';
        else if ([50,51,52,55,56,57,58,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79].includes(prefix)) range='3–4';
        else if (prefix===59 || (prefix>=80 && prefix<=99)) range='4–5';
        if ((regional>=962 && regional<=969) || regional>=995) range='';
        this.status.textContent = !range ? this.dataset.contact : this.dataset.available!=='true' ? this.dataset.stock : this.dataset.result.replace('[days]',range);
        if (range && this.dataset.available==='true') {
          this.status.classList.add('is-estimate');
          this.showTown(zip.slice(0,5),range,requestId);
        }
        if (broadcast) { try { sessionStorage.setItem('ipx-delivery-zip',zip); } catch {} window.dispatchEvent(new CustomEvent('ipx-delivery-zip',{detail:zip})); }
      }
      async showTown(zip,range,requestId) {
        try {
          IpxDeliveryChecker.towns ||= new Map();
          let location=IpxDeliveryChecker.towns.get(zip);
          if (!location) {
            const response=await fetch('https://api.zippopotam.us/us/'+zip,{credentials:'omit',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(5000)});
            if (!response.ok) return;
            const data=await response.json();
            const place=data.places?.[0];
            if (!place?.['place name'] || !place?.['state abbreviation']) return;
            location={town:place['place name']+', '+place['state abbreviation'],latitude:Number(place.latitude),longitude:Number(place.longitude)};
            IpxDeliveryChecker.towns.set(zip,location);
          }
          if (!this.isConnected || this.requestId!==requestId || this.input.value.trim().slice(0,5)!==zip) return;
          this.status.textContent=this.dataset.townResult.replace('[town]',location.town).replace('[days]',range);
          const {latitude,longitude}=location;
          if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || Math.abs(latitude)>90 || Math.abs(longitude)>180) return;
          this.map.hidden=false;
          const drawMap=() => {
            const width=this.map.clientWidth;
            if (!width) return;
            const zoom=11, scale=2**zoom;
            const x=(longitude+180)/360*scale*256;
            const rad=Math.max(-85,Math.min(85,latitude))*Math.PI/180;
            const y=(1-Math.asinh(Math.tan(rad))/Math.PI)/2*scale*256;
            const left=x-width/2, top=y-90;
            const tiles=document.createDocumentFragment();
            for (let tx=Math.floor(left/256);tx<=Math.floor((left+width-1)/256);tx++) {
              for (let ty=Math.floor(top/256);ty<=Math.floor((top+179)/256);ty++) {
                if (ty<0 || ty>=scale) continue;
                const image=document.createElement('img');
                image.alt=''; image.width=256; image.height=256;
                image.referrerPolicy='strict-origin-when-cross-origin';
                image.src='https://tile.openstreetmap.org/'+zoom+'/'+((tx%scale+scale)%scale)+'/'+ty+'.png';
                image.style.left=(tx*256-left)+'px'; image.style.top=(ty*256-top)+'px';
                image.addEventListener('error',()=>{ if (this.requestId===requestId) this.hideMap(); },{once:true});
                tiles.append(image);
              }
            }
            const pin=document.createElement('span'); pin.className='ipx-delivery__map-pin'; pin.setAttribute('aria-hidden','true');
            const credit=document.createElement('a'); credit.className='ipx-delivery__map-credit'; credit.href='https://www.openstreetmap.org/copyright'; credit.target='_blank'; credit.rel='noopener'; credit.textContent='© OpenStreetMap contributors';
            tiles.append(pin,credit); this.map.replaceChildren(tiles);
            this.map.setAttribute('aria-label',location.town+' — '+zip);
          };
          drawMap();
          let mapWidth=this.map.clientWidth;
          this.mapObserver=new ResizeObserver(()=>{ const width=this.map.clientWidth; if (width && width!==mapWidth) { mapWidth=width; drawMap(); } });
          this.mapObserver.observe(this.map);
        } catch {}
      }
    }
    customElements.define('ipx-delivery-checker',IpxDeliveryChecker);
  }
  } catch(e) { console.error(e); }
})();

})();
